import classNames from 'classnames';
import PaginationMiddle from './PaginationMiddle';
import PaginationStart from './PaginationStart';
import PaginationEnd from './PaginationEnd';
import Icon from '@/components/Icon/Icon';

export const MAX_DISPLAYED_PAGES = 5;
export const MAX_DISPLAYED_SIDES = 3;

export type TPaginationProps = {
    handlePageOpen: (pageIdx: number) => void;
    totalPages: number;
    currentPageIdx: number;
    className?: string;
};

type TPaginationItemsProps = {
    currentPageIdx: number;
    handlePageOpen: (pageIdx: number) => void;
    totalPages: number;
};

const PaginationItems = ({ currentPageIdx, handlePageOpen, totalPages }: TPaginationItemsProps) => {
    const isSelectedIdxInTheMiddle =
        currentPageIdx > MAX_DISPLAYED_SIDES &&
        currentPageIdx < totalPages - 1 - MAX_DISPLAYED_SIDES;
    const isSelectedIdxAtTheEnd = currentPageIdx >= totalPages - 1 - MAX_DISPLAYED_SIDES;
    const isSelectedIdxAtTheBeginning = currentPageIdx <= MAX_DISPLAYED_SIDES;
    const items = [];

    if (totalPages <= MAX_DISPLAYED_PAGES) {
        for (let i = 0; i < totalPages; i++) {
            items.push(
                <button
                    key={i}
                    className={classNames('tw-px-[10px] focus:tw-outline-none', {
                        'tw-text-paginationActive': currentPageIdx === i,
                        'tw-text-paginationInactive': currentPageIdx !== i,
                        'hover:tw-bg-[#eee]': currentPageIdx !== i,
                    })}
                    onClick={() => handlePageOpen(i)}
                >
                    {i + 1}
                </button>,
            );
        }
    } else {
        if (isSelectedIdxInTheMiddle) {
            return (
                <PaginationMiddle
                    handlePageOpen={handlePageOpen}
                    currentPageIdx={currentPageIdx}
                    totalPages={totalPages}
                />
            );
        } else if (isSelectedIdxAtTheBeginning) {
            return (
                <PaginationStart
                    handlePageOpen={handlePageOpen}
                    currentPageIdx={currentPageIdx}
                    totalPages={totalPages}
                />
            );
        } else if (isSelectedIdxAtTheEnd) {
            return (
                <PaginationEnd
                    handlePageOpen={handlePageOpen}
                    currentPageIdx={currentPageIdx}
                    totalPages={totalPages}
                />
            );
        }
    }
    return items;
};

const Pagination = ({
    handlePageOpen,
    totalPages,
    currentPageIdx,
    className,
}: TPaginationProps) => {
    return (
        <nav className={className}>
            <div className="tw-inline-flex tw-flex-row tw-text-[18px] tw-items-center">
                <button
                    className={classNames(
                        'tw-px-[5px] tw-text-2xl tw-text-pink1 disabled:tw-opacity-20 [&:not(:disabled)]:hover:tw-bg-[#eee] focus:tw-outline-none',
                    )}
                    onClick={() => handlePageOpen(currentPageIdx - 1)}
                    disabled={currentPageIdx === 0}
                >
                    <Icon
                        type="angleLeft"
                        width={24}
                        height={24}
                        className="tw-align-middle tw-fill-[#ce0058] tw-translate-y-[-2px]"
                    />
                </button>
                <PaginationItems
                    currentPageIdx={currentPageIdx}
                    handlePageOpen={handlePageOpen}
                    totalPages={totalPages}
                />
                <button
                    className="tw-px-[5px] tw-text-2xl tw-text-pink1 disabled:tw-opacity-20 [&:not(:disabled)]:hover:tw-bg-[#eee] focus:tw-outline-none"
                    onClick={() => handlePageOpen(currentPageIdx + 1)}
                    disabled={currentPageIdx === totalPages - 1}
                >
                    <Icon
                        type="angleRight"
                        width={24}
                        height={24}
                        className="tw-align-middle tw-fill-[#ce0058] tw-translate-y-[-2px]"
                    />
                </button>
            </div>
        </nav>
    );
};

export default Pagination;
